import React from 'react';

import { TColumns } from '@dashboard/components/EmailMessagesList';
import { FEmailMessageLightFragment, useWaypointTemplateQuery } from '@dashboard/generated/wp/platform';
import { getEmailMessageSourceLabel } from '@dashboard/models/EmailMessage';
import { Skeleton, Typography } from '@mui/material';

import { DateFormatter } from '@waypoint/react-formatters';

import LastEventColumn from './LastEventColumn';

type Props = {
  row: FEmailMessageLightFragment;
};

export function TemplateName({ row }: Props) {
  const { data } = useWaypointTemplateQuery({
    variables: { id: row.waypointTemplateId ?? '' },
    skip: row.waypointTemplateId === null,
  });

  if (row.waypointTemplateId === null) {
    return <Typography color="text.secondary">--</Typography>;
  }
  const template = data?.WaypointTemplate;
  if (template === undefined) {
    return <Skeleton />;
  }

  return <Typography noWrap>{template.name}</Typography>;
}

const COLUMNS: TColumns = [
  { headerName: 'Event', renderCell: LastEventColumn, minWidth: 128, maxWidth: 128 },
  {
    headerName: 'Source',
    minWidth: 128,
    maxWidth: 128,
    renderCell: ({ row }) => <Typography noWrap>{getEmailMessageSourceLabel(row.source)}</Typography>,
  },
  {
    headerName: 'Timestamp',
    renderCell: ({ row }) => <DateFormatter value={row.createdAt} />,
    minWidth: 176,
    maxWidth: 192,
  },
  {
    headerName: 'Template',
    renderCell: TemplateName,
  },
  {
    headerName: 'Recipient',
    renderCell: ({ row }) => <Typography noWrap>{row.message.to}</Typography>,
  },
  {
    headerName: 'From',
    renderCell: ({ row }) => <Typography noWrap>{row.message.from}</Typography>,
  },
  {
    headerName: 'ID',
    renderCell: ({ row }) => <Typography noWrap>{row.id}</Typography>,
    minWidth: 128,
    maxWidth: 200,
  },
];

export default COLUMNS;
